import React, { Component } from "react"
import { connect } from "react-redux"
import styled from "styled-components"
import ReactTable from "react-table"
import "react-table/react-table.css"
import "../../style/react-table-custom.css"

import request from "../../utils/request"
import Pagination from "../../components/paginationTable/pagination"
import Button from "../../components/button"
import TabComponent from "../../components/tabComponent"
import swal from "sweetalert"

import WhiteListModal from "../../components/whiteListModal"

const Card = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;
  border-radius: 5px;
  border: 1px solid ${(props) => props.theme.active};
  background: #fff;
  height: max-content;
  width: 100%;
  position: relative;
  top: -1px;
  padding: 10px;
  align-items: flex-start;
  overflow: auto;
`

const TextCollum = styled.div`
  margin-bottom: 0.5rem;
  font-size: 13px;
  font-weight: 500;
  line-height: 1.2;
  color: inherit;
`

const Overlay = styled.div`
  content: " ";
  z-index: 10;
  display: block;
  position: absolute;
  height: 100%;
  top: 0;
  left: 0;
  right: 0;
  background: rgba(255, 255, 255, 0.8);
`

class WhiteListPage extends Component {
  constructor(props) {
    super(props)

    this.state = {
      // table
      data: [],
      tempDataTable: [],
      loading: false,
      page: 0,
      totalPages: 0,
      totaldata: 0,
      limit: 5000,

      columnWillShow: [],
      showModalAddWhiteList: false,
      textSearch: "",
      checkLastFetchTime: 0,
    }
  }

  async getDataWhiteList(pageObj) {
    const page = pageObj && pageObj.page ? pageObj.page : 1
    const { limit } = this.state

    const params = {
      page,
      limit,
    }

    this.setState({ loading: true, data: [], tempDataTable: [] })

    const lastFetchTime = new Date().getTime()
    this.setState({ checkLastFetchTime: lastFetchTime })

    const url =
      `/setting/white_list/list?` +
      `page=${params.page}` +
      `&limit=${params.limit}`
    try {
      const resp = await request.get(url)
      const data = resp.data
      console.log(data);
      if (this.state.checkLastFetchTime !== lastFetchTime) return

      const items = data || []
      const itemCount = data.length || 0

      this.setState({
        data: items,
        tempDataTable: items,
        loading: false,
        totaldata: itemCount,
        totalPages: Math.ceil(itemCount / limit),
      })
    } catch (err) {
      this.setState({ loading: false, data: [], tempDataTable: [], totaldata: 0, totalPages: 0 })
    }
  }

  async toggleCanUse(whiteList) {
    if (!whiteList || !whiteList.id) {
      alert("No White List ID")
      return
    }

    try {
      const result = await request
        .post(
          `/setting/white_list/id/${whiteList.id}/toggle`,
          {
            can_use: !whiteList.can_use,
          },
          false
        )
        .then((res) => res.data)
        .catch((err) => {
          console.log(err)
          alert("Error while toggling white list")
          return
        })

      if (result) {
        this.getDataWhiteList({ page: 1 })
      }
    } catch (err) {
      console.log(err)
      return
    }
  }

  async deleteWhiteList(whiteList) {
    if (!whiteList || !whiteList.id) {
      alert("No White List ID")
      return
    }

    swal({
      title: "Are you sure?",
      text: `You want to delete this phone number: ${whiteList.phone} from whitelist ?`,
      icon: "warning",
      buttons: true,
      dangerMode: true,
    }).then(async (willDelete) => {
      if (willDelete) {
        try {
          const result = await request
            .post(
              `/setting/white_list/id/${whiteList.id}/delete`,
              {},
              false
            )
            .then((res) => res.data)
            .catch((err) => {
              console.log(err)
              alert("Error while deleting white list")
              return
            })

          if (result) {
            this.getDataWhiteList({ page: 1 })
          }
        } catch (err) {
          console.log(err)
          return
        }
      }
    });
  }

  handleAddWhiteList = () => {
    this.setState({ showModalAddWhiteList: true })
  }

  async componentDidMount() {
    this.setColumWillShow()
    this.setState({}, () => {
      this.getDataWhiteList({ page: 1 })
    })
  }

  // ---------- columns ----------
  setColumWillShow = () => {
    const columns = [
      // Phone number, Total Accounts, Action
      {
        Header: () => <TextCollum>Team phone numbers whitelisted</TextCollum>,
        accessor: "phone",
        Cell: (row) => <div>{row.original.phone}</div>,
      },
      {
        Header: () => <TextCollum>Total accounts whitelisted</TextCollum>,
        accessor: "user_count",
        Cell: (row) => <div>{row.original.user_count}</div>,
      },
      {
        Header: () => <TextCollum>Action</TextCollum>,
        accessor: "action",
        width: 200,
        Cell: (row) => {
          return row.original.user_count === 0 ? (
            <div>
              <Button
                style={{
                  width: "auto",
                  fontSize: "12px",
                  padding: "5px 10px",
                  height: "22px",
                  lineHeight: "12px",
                }}
                className="btn"
                label="Delete"
                onClick={() => this.deleteWhiteList(row.original)}
              />
            </div>
          ) : (
            <div
              style={{ cursor: "pointer", width: "60px" }}
              onClick={() => this.toggleCanUse(row.original)}
            >
              <p
                style={{
                  textAlign: "center",
                  margin: 0,
                  borderRadius: "10px",
                  backgroundColor: row.original.can_use ? "#6e8ca0" : "#ccd1d3",
                  color: row.original.can_use ? "white" : "#324755",
                }}
              >
                {row.original.can_use ? "On" : "Off"}
              </p>
            </div>
          );
        },

      },
    ]

    this.setState({ columnWillShow: columns })
  }

  compareBy(key, order) {
    return function (a, b) {
      // a[key] = a[key] === null || a[key] === undefined ? -Infinity : a[key];
      // b[key] = b[key] === null || b[key] === undefined ? -Infinity : b[key];

      // a[key] = typeof a[key] === "string" ? a[key].toLowerCase() : a[key];
      // b[key] = typeof b[key] === "string" ? b[key].toLowerCase() : b[key];

      if (order) {
        if (a[key] < b[key]) {
          return 1
        }
        if (a[key] > b[key]) {
          return -1
        }
        return 0
      } else {
        if (a[key] > b[key]) {
          return 1
        }
        if (a[key] < b[key]) {
          return -1
        }
        return 0
      }
    }
  }

  onSentTextSearch = () => {
    const { textSearch, data } = this.state
    if (textSearch === "") {
      this.setState({ tempDataTable: [] })
      return
    }

    const filteredData = data.filter((item) => {
      return item.phone.toString().includes(textSearch)
    })

    this.setState({ tempDataTable: filteredData })
  }

  async togleSorting(newSorted, column, shiftKey) {
    let arrayCopy =
      (await this.state.tempDataTable.length) > 0
        ? [...this.state.tempDataTable]
        : [...this.state.data]
    await arrayCopy.sort(this.compareBy(column.id, newSorted[0].desc))
    this.setState({ data: arrayCopy, tempDataTable: arrayCopy })
  }

  render() {
    const tabData = [{ label: "WhiteList", total: this.state.totaldata, key: "3", path: "/whitelist" }]

    return (
      <div>
        <div className="col-md-12" style={{ 
          paddingBottom: "10px", 
          marginTop: "20px",
          display: "flex", 
          justifyContent: "space-between", 
          alignItems: "center"
          }}>
          <div className="row">
            <Button style={{ width: "auto" }} className="btn" label="+ Add team’s phone number" onClick={() => this.handleAddWhiteList()} />
          </div>
          <div style={{ display: "flex", flexDirection: "row" }}>
            <input
              id="searchText"
              type="text"
              className="inPut-search-textMaild"
              placeholder="Search.."
              name="textSearch"
              value={this.state.textSearch}
              onChange={(e) => this.setState({ textSearch: e.target.value })}
              onKeyPress={(event) => {
                if (event.key === "Enter") {
                  this.onSentTextSearch()
                }
              }}
            />
            <button
              id="searchTextmaid"
              type="submit"
              className="search-containe-button"
              onClick={this.onSentTextSearch}>
              <i className="fa fa-search"></i>
            </button>
          </div>
        </div>

        <div style={{ marginBottom: "10px", color: "red" }}>
          **ใช้สำหรับเพิ่มหมายเลขโทรศัพท์สมาชิกทีมเท่านั้น ห้ามเพิ่มหมายเลขโทรศัพท์ของลูกค้าลงในส่วนนี้เด็ดขาด**
        </div>

        <TabComponent transparent tabData={tabData} />

        <Card className="col-md-12">
          <ReactTable
            data={this.state.tempDataTable.length > 0 ? this.state.tempDataTable : this.state.data}
            columns={this.state.columnWillShow}
            loading={this.state.loading}
            pageSize={25}
            page={this.state.page}
            showPagination={true}
            PaginationComponent={Pagination}
            pages={this.state.totalPages}
            manual
            onPageChange={(page) => this.setState({ page }, () => this.getDataWhiteList({ page: page + 1 }))}
            getTrProps={() => ({ style: { height: 25, overflow: "hidden" } })}
            className="-striped -highlight bookingLsittetable"
            onSortedChange={(newSorted, column, shiftKey) =>
              this.togleSorting(newSorted, column, shiftKey)
            }
          />
        </Card>

        <WhiteListModal
          isOpen={this.state.showModalAddWhiteList}
          closeModal={(data) => {
            this.setState({ showModalAddWhiteList: data }, () => console.log(data))
          }}
          updateWhiteList={(data) => {
            this.setState({ showModalAddWhiteList: false })
            this.getDataWhiteList({ page: 1 })
          }}
        />
      </div>
    )
  }
}

const mapState = (state) => ({})

const mapDispatch = (dispatch) => {
  return {
  }
}

export default connect(mapState, mapDispatch)(WhiteListPage)
